import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { PaperPlaneTilt, ShieldCheck } from "@phosphor-icons/react";

const ITEMS = [
  "Checked all emails",
  "Checked LOAs",
  "Checked Task Assigned",
  "Checked Reports",
];

export function SendChecklistDialog({ open, onOpenChange, onConfirm, sending }) {
  const [checked, setChecked] = useState({});

  useEffect(() => { if (open) setChecked({}); }, [open]);

  const allChecked = ITEMS.every((_, i) => checked[i]);
  const toggle = (i) => setChecked((p) => ({ ...p, [i]: !p[i] }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><ShieldCheck size={22} className="text-primary" /> Before you send</DialogTitle>
          <DialogDescription>A quick reminder — tick what you've done, then send. (Optional)</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-1">
          {ITEMS.map((item, i) => (
            <label key={i} data-testid={`checklist-item-${i}`} onClick={() => toggle(i)}
              className={`flex items-center gap-3 rounded-xl border px-3 py-3 cursor-pointer transition-colors duration-200 ${checked[i] ? "bg-primary/5 border-primary/30" : "bg-white border-border hover:bg-secondary/50"}`}>
              <Checkbox checked={!!checked[i]} className="pointer-events-none" />
              <span className={`text-sm ${checked[i] ? "text-foreground font-medium" : "text-muted-foreground"}`}>{item}</span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="rounded-md">Cancel</Button>
          <Button data-testid="checklist-confirm-send" disabled={sending} onClick={onConfirm}
            className="rounded-full bg-primary hover:bg-primary/90">
            <PaperPlaneTilt size={18} className="mr-1.5" /> {sending ? "Sending…" : "Send Report"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
